export function getInitialCustomFieldState(value) {
  const normalizedValue = value || "";

  return {
    textValue: normalizedValue,
    numberValue: normalizedValue,
    lastApiValue: normalizedValue,
    choiceValue: normalizedValue,
  };
}

export function getParsedChoiceValues(choiceValue) {
  if (!choiceValue) {
    return [];
  }

  try {
    const parsedValue = JSON.parse(choiceValue);
    return Array.isArray(parsedValue) ? parsedValue : [];
  } catch (_error) {
    return [];
  }
}

export function getNextCheckboxValue(choiceValue, optionName, isChecked) {
  const selectedValues = getParsedChoiceValues(choiceValue);
  const nextValues = isChecked
    ? [...selectedValues, optionName]
    : selectedValues.filter((value) => value !== optionName);

  return nextValues.length ? JSON.stringify(nextValues) : "";
}

export function hasTextValueChanged(textValue, lastApiValue) {
  return textValue !== lastApiValue;
}

export function hasNumberValueChanged(numberValue, lastApiValue) {
  return Number(numberValue) !== Number(lastApiValue);
}

export function getCustomFieldInvalidateKeys(cardId, boardId) {
  const invalidateKeys = [
    ["card", cardId],
    ["history", cardId],
    ["mineCards"],
    ["userCards"],
    ["assignedCards"],
    ["watching"],
  ];

  if (boardId || boardId === 0) {
    invalidateKeys.push(["cards", Number(boardId)]);
  }

  return invalidateKeys;
}
